window.$ = window.jQuery = require('jquery');
window.Popper = require('popper.js');
require('bootstrap');
import 'slick-carousel';


